import { FC, ImgHTMLAttributes } from 'react';
import Image from './assets/images/sellerContactHero.png';

const ImageSellerContactHero: FC<ImgHTMLAttributes<never>> = (props) => {
  return <img src={Image} alt="Seller Contact Image" style={{ maxWidth: '100%', maxHeight: '100%' }} {...props} />;
};

export default ImageSellerContactHero;
